<div class="info-group">
  <project-overview-header
    [data]="data"
    [expanded]="expanded"
    [type]="type"
    [enableSubmitAllBids]="enableSubmitAllBids"
    [enableAcceptAllOffers]="enableAcceptAllOffers"
    [numberOfBids]="numberOfBids"
    [showAtp]="showAtp"
    (toggled)="changeOpenState($event)"
  ></project-overview-header>
  <project-overview-table
    [projectId]="data?.projectId"
    [data]="data?.sites"
    [tableA]="tableA"
    [showTableA]="showTableA"
    [type]="type"
    [expanded]="expanded"
    [index]="index"
    (handleSitesUpdate)="handleSitesUpdate($event)"
  ></project-overview-table>
</div>
